import TransactionCard from '@components/TransactionCard';
import { ITransaction, ITransactions } from '@interfaces/transaction';
import Skeleton from './Skeleton';
import { IRedemption } from '@interfaces/redemption';
import { TRANSACTION_CATEGORY } from '@constants/transaction.constants';

type TransactionsProps = {
	transactions: ITransactions<ITransaction | IRedemption>[],
	isLoading: boolean,
	category?: TRANSACTION_CATEGORY
}

export default function Transactions({ transactions, isLoading, category }: TransactionsProps) {
	return (
		<div className='flex flex-col w-full desktop:w-[840px] z-10'>
			{isLoading && transactions.length === 0
				? <Skeleton />
				: (
					<>
						{transactions?.length > 0 ? (
							<>
								<div className='flex flex-col w-full px-6 pb-6 mt-6 desktop:mt-10 gap-4 desktop:bg-[#00000008] desktop:mb-6 rounded-t-lg relative'>
									{transactions.map((group, i) => {
										let isFirst = false;
										if (i === 0) isFirst = true;
										return <TransactionCard transactionGroup={group} isFirst={isFirst} key={group.createdAt} category={category}/>;
									})}
								</div>
							</>
						) : (
							<>
								<h3 className='text-white text-center z-10 font-semibold mt-16 mb-14 desktop:my-[88px] text-lg'>
									No records to show in last 3 days
								</h3>
							</>)}
					</>
				)}
		</div>
	);
}
